// extracted by mini-css-extract-plugin
export default {"bui-u-bleed--small":"BUIProvider_bui-u-bleed--small__FwuBQ"};